export default __webpack_public_path__ + "static/index-title-news-zh-Hans-c73955778ddddf779a1b96bce75939b1.png";